import { getUserConfiguration } from 'owa-session-store';
import type FeatureSource from '../constants/source';
import type { BookingCustomAttributesType } from '../schema/bookingCustomAttributesType';

const getBookingRequestOptions = (
    options: any,
    bookingCustomAttributes?: BookingCustomAttributesType
): any => {
    let mailbox;
    if (bookingCustomAttributes?.source === 'BookWithMe') {
        mailbox = getUserConfiguration().SessionSettings?.UserPrincipalName ?? '';
    } else {
        mailbox =
            bookingCustomAttributes?.mailboxId ??
            getUserConfiguration().ViewStateConfiguration?.SelectedBookingMailbox ??
            '';
        ('');
    }

    const { context } = options;

    const headers = {
        ...context?.headers,
        'X-AnchorMailbox': mailbox,
        'X-Prefer-Service': 'ItemClient',
    };

    options.context = { ...context, headers };

    return options;
};

export default getBookingRequestOptions;
